import { useIpInfo } from 'hooks/useIpInfo'
import { useUserProfile } from 'hooks/useUserProfile'
import { useQuery } from 'react-query'
import { determineUserCountry } from 'utils/region'

/**
 * Determines the user's country based on their profile (if logged in), otherwise based on their IP.
 */
export function useUserCountry() {
  const { data: userProfile } = useUserProfile()
  const { data: ipInfo } = useIpInfo()

  /**
   * Implemented with useQuery to cache the result.
   */
  const { data: userCountry } = useQuery({
    queryKey: [
      'user-country',
      userProfile?.shippingAddress?.country,
      ipInfo?.country,
    ],
    queryFn: () => {
      return determineUserCountry(userProfile, ipInfo)
    },
    refetchOnWindowFocus: false,
    initialData: null,
    keepPreviousData: true,
  })

  return { userCountry: userCountry || null, isDetermining: !userCountry }
}
